let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cqWlH")).then(() => parcelRequire('4Y8D1'));